'use client';
import { Pagination as CPagination } from 'antd';

interface IProps {
  onChange?: (page: number, pageSize: number) => void;
  pageSize: number | undefined;
  current: number | undefined;
  total: number | undefined;
  pageDisable?: number[];
  showSizeChanger?: boolean;
}

const Pagination: React.FC<IProps> = ({
  onChange,
  pageSize,
  current,
  total,
  pageDisable,
  showSizeChanger = false,
}) => {
  const itemRender = (
    page: number,
    type: string,
    originalElement: React.ReactNode,
  ) => {
    if (['prev', 'next'].includes(type)) return originalElement;
    if ((pageDisable || []).includes(page) && type === 'page') {
      return (
        <span
          className="pagination-disable"
          style={{
            color: '#ccc',
            pointerEvents: 'none',
            cursor: 'not-allowed',
            width:'100%',
            height:'100%',
          }}
        >
          {page}
        </span>
      );
    }
    return originalElement;
  };

  return (
    <CPagination
      onChange={onChange}
      align="center"
      defaultCurrent={1}
      pageSize={pageSize}
      current={current}
      total={total}
      itemRender={itemRender}
      showSizeChanger={showSizeChanger}
    />
  );
};

export default Pagination;
